// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* COMMON STYLES FOR BOTH FIELDS */

.trimble-search .sui-search-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  align-self: stretch;
  width: 100%;
  justify-content: space-between;

  background-color: white;
  border: 1px solid rgba(23, 28, 30, 0.6);
  border-radius: 0.25rem;
}

.trimble-search .sui-search-box .sui-search-box__wrapper {
  justify-content: center;
  align-self: stretch;
  width: 100%;
  height: inherit;
}

.trimble-search .sui-search-box .sui-search-box__text-input {
  background-color: transparent !important;
  color: var(--primary-black) !important;
  display: flex;
  border: none;
  border-radius: 0;
  padding: 0 0 0 1rem;
  box-shadow: none !important;
  height: 100%;

  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.024px;
  font-style: normal;
  line-height: 24px;
}

.trimble-search .sui-search-box .sui-search-box__text-input:focus {
  outline: 2px solid var(--primary-black) !important;
  outline-offset: -2px;
  border-radius: 0.25rem;
  box-shadow: 0px 0px 0px 2px rgb(255, 255, 255, 0.8) !important;
}

.trimble-search .sui-search-box>button {
  display: flex;
  align-items: center;
  justify-content: center;

  background: none !important;
  background-color: transparent !important;

  margin: 0 !important;
  border: none !important;
  border-radius: 0 !important;
  padding: 0;

  width: 2.5rem;
  height: 2.5rem;

  text-shadow: none !important;
  box-shadow: none !important;
}

.trimble-search .sui-search-box>button:hover,
.trimble-search .sui-search-box>button:focus {
  background-color: transparent !important;
}

.trimble-search .sui-search-box>button svg {
  width: 1rem;
  height: 1rem;
}

.trimble-search .sui-search-box .sui-search-box__autocomplete-container {
  font-family: inherit;
  border-radius: 0;
  border: 1px solid var(--primary-black-opacity-20);
  background-color: #FFF;
  padding: 0;
  margin: 0;
}

.trimble-search .sui-search-box .sui-search-box__autocomplete-container .sui-search-box__section-title {
  font-size: 1.25rem !important;
  line-height: 1.75rem !important;
  padding-bottom: 0.5rem;
  font-weight: bold;
  text-transform: none;
  letter-spacing: normal;
}

.trimble-search .sui-search-box .sui-search-box__autocomplete-container .sui-search-box__results-list>li {
  display: flex;
  align-items: center;
  overflow-wrap: break-word;

  border-radius: 0;
  margin: 0;
  min-height: 2.5rem;
}

.trimble-search .sui-search-box .sui-search-box__autocomplete-container .sui-search-box__results-list>li[aria-selected="true"] {
  background-color: var(--button-hover-bg-color);
}

.trimble-search .sui-search-box .sui-search-box__autocomplete-container .sui-search-box__results-list>li:hover {
  background-color: var(--button-hover-bg-color);
}

/* LARGE SEARCH FIELD */

.trimble-search .search-field .sui-search-box {
  height: 3rem;
}

.trimble-search .search-field .sui-search-box>button {
  width: 3rem;
  height: 3rem;
}

.trimble-search .search-field .sui-search-box .sui-search-box__autocomplete-container {
  width: calc(100% + 4rem);
  top: 100%;
}

/* SIDEBAR */

.trimble-search .sui-layout-sidebar .sui-search-box .sui-search-box__autocomplete-container {
  width: 100%;
  top: 105%;
}

.trimble-search .sui-layout-sidebar .sui-search-box {
  height: 2.5rem;
}

.trimble-search .sui-layout-sidebar .sui-search-box>button {
  width: 2.5rem;
  height: 2.5rem;
}`, "",{"version":3,"sources":["webpack://./src/components/search-field/searchfield.css"],"names":[],"mappings":"AAAA,kCAAkC;;AAElC;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,8BAA8B;;EAE9B,uBAAuB;EACvB,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,sCAAsC;EACtC,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;;EAEZ,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kDAAkD;EAClD,oBAAoB;EACpB,sBAAsB;EACtB,8DAA8D;AAChE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,2BAA2B;EAC3B,wCAAwC;;EAExC,oBAAoB;EACpB,uBAAuB;EACvB,2BAA2B;EAC3B,UAAU;;EAEV,aAAa;EACb,cAAc;;EAEd,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,iDAAiD;EACjD,sBAAsB;EACtB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;;EAEzB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;AAChD;;AAEA,uBAAuB;;AAEvB;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;;AAEZ;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB","sourcesContent":["/* COMMON STYLES FOR BOTH FIELDS */\n\n.trimble-search .sui-search-box {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 1rem;\n  align-self: stretch;\n  width: 100%;\n  justify-content: space-between;\n\n  background-color: white;\n  border: 1px solid rgba(23, 28, 30, 0.6);\n  border-radius: 0.25rem;\n}\n\n.trimble-search .sui-search-box .sui-search-box__wrapper {\n  justify-content: center;\n  align-self: stretch;\n  width: 100%;\n  height: inherit;\n}\n\n.trimble-search .sui-search-box .sui-search-box__text-input {\n  background-color: transparent !important;\n  color: var(--primary-black) !important;\n  display: flex;\n  border: none;\n  border-radius: 0;\n  padding: 0 0 0 1rem;\n  box-shadow: none !important;\n  height: 100%;\n\n  font-size: 16px;\n  font-weight: 400;\n  letter-spacing: 0.024px;\n  font-style: normal;\n  line-height: 24px;\n}\n\n.trimble-search .sui-search-box .sui-search-box__text-input:focus {\n  outline: 2px solid var(--primary-black) !important;\n  outline-offset: -2px;\n  border-radius: 0.25rem;\n  box-shadow: 0px 0px 0px 2px rgb(255, 255, 255, 0.8) !important;\n}\n\n.trimble-search .sui-search-box>button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  background: none !important;\n  background-color: transparent !important;\n\n  margin: 0 !important;\n  border: none !important;\n  border-radius: 0 !important;\n  padding: 0;\n\n  width: 2.5rem;\n  height: 2.5rem;\n\n  text-shadow: none !important;\n  box-shadow: none !important;\n}\n\n.trimble-search .sui-search-box>button:hover,\n.trimble-search .sui-search-box>button:focus {\n  background-color: transparent !important;\n}\n\n.trimble-search .sui-search-box>button svg {\n  width: 1rem;\n  height: 1rem;\n}\n\n.trimble-search .sui-search-box .sui-search-box__autocomplete-container {\n  font-family: inherit;\n  border-radius: 0;\n  border: 1px solid var(--primary-black-opacity-20);\n  background-color: #FFF;\n  padding: 0;\n  margin: 0;\n}\n\n.trimble-search .sui-search-box .sui-search-box__autocomplete-container .sui-search-box__section-title {\n  font-size: 1.25rem !important;\n  line-height: 1.75rem !important;\n  padding-bottom: 0.5rem;\n  font-weight: bold;\n  text-transform: none;\n  letter-spacing: normal;\n}\n\n.trimble-search .sui-search-box .sui-search-box__autocomplete-container .sui-search-box__results-list>li {\n  display: flex;\n  align-items: center;\n  overflow-wrap: break-word;\n\n  border-radius: 0;\n  margin: 0;\n  min-height: 2.5rem;\n}\n\n.trimble-search .sui-search-box .sui-search-box__autocomplete-container .sui-search-box__results-list>li[aria-selected=\"true\"] {\n  background-color: var(--button-hover-bg-color);\n}\n\n.trimble-search .sui-search-box .sui-search-box__autocomplete-container .sui-search-box__results-list>li:hover {\n  background-color: var(--button-hover-bg-color);\n}\n\n/* LARGE SEARCH FIELD */\n\n.trimble-search .search-field .sui-search-box {\n  height: 3rem;\n}\n\n.trimble-search .search-field .sui-search-box>button {\n  width: 3rem;\n  height: 3rem;\n}\n\n.trimble-search .search-field .sui-search-box .sui-search-box__autocomplete-container {\n  width: calc(100% + 4rem);\n  top: 100%;\n}\n\n/* SIDEBAR */\n\n.trimble-search .sui-layout-sidebar .sui-search-box .sui-search-box__autocomplete-container {\n  width: 100%;\n  top: 105%;\n}\n\n.trimble-search .sui-layout-sidebar .sui-search-box {\n  height: 2.5rem;\n}\n\n.trimble-search .sui-layout-sidebar .sui-search-box>button {\n  width: 2.5rem;\n  height: 2.5rem;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
